import React from 'react'

export default function ComingSoon() {
    return <div>ComingSoon</div>
}
